import { render, staticRenderFns } from "./PrintConnectorArticle.vue?vue&type=template&id=2688039b"
import script from "./PrintConnectorArticle.vue?vue&type=script&lang=js"
export * from "./PrintConnectorArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports